import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Header1 from './component/Header1'; // Adjust the path if needed
import TermsAndConditions from "./pages/Terms";
import CSPBankingPage from "./pages/csp";
import WLALandingPage from "./pages/atm";

// service page
import WebsiteDevelopment from "./services/WebsiteDevelopment";
import "./App.css";
import Contact from "./pages/Contact";
import ItManagement from "./services/It-Management";
import SoftwareDevelopment from "./services/SoftwareDevelopment";
import CRM from "./services/CRM-Solution";
import DataTracking from "./services/Data-Tracking";
import AppDevelopment from "./services/AppDevelopment";
import Career from "./pages/Career";
import Portfolio from "./pages/Portfolio";
import Scroll from "./component/Scroll";
import Footer from "./pages/Footer";
import Pricing from "./pages/Pricing";
import FAQ from "./pages/Faq";
import NotFound from "./pages/NotFound";
import PMWANILPage from "./pages/pmwani";
import ETPlKendra from "./pages/services";

const App = () => {
  return (
    <Router>
      <div>
      <Scroll/>
        <Header1/>

        <Routes>
          <Route path="/" element={<Home />} />

          {/* services */}
          {/* {/* <Route path="/website-development" element={<WebsiteDevelopment />} />
          <Route path="/it-management" element={<ItManagement />} />
          <Route path="/software-development" element={<SoftwareDevelopment />} /> */}
          <Route path="/services" element={<ETPlKendra />} />  
          <Route path="/atm" element={<WLALandingPage/>} /> 
          <Route path="/csp-point" element={<CSPBankingPage />} />  




          <Route path="/" element={<Portfolio />} /> {/* Services page route */}
                    <Route path="/pm-wani" element={<PMWANILPage />} /> {/* Services page route */}

          <Route path="/Careers" element={<Career />} /> Services page route
          <Route path="/contact-us" element={<Contact />} /> {/* Services page route */}
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} /> {/* Services page route */}
            {/* Catch-all route for undefined paths */}
            <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer/>

      </div>
    </Router>
  );
};

export default App;
